import http from 'hub-http/clients/apiClient';
import { PropertyObjectTypes, PropertyObjectTypesIds } from 'FormsCommonComponents/js/constants/PropertyObjectTypes';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
import { getPropertyFrequencyKey, getCountSubmissionsKey, getCRMSearchForTotalKey
// @ts-expect-error untyped dependency
} from 'FormsUI/earlyRequest/earlyRequestsShared';
import { URL_DATE_FORMAT } from 'FormsUI/constants/DateFormats';
import { DEFAULT_FRAMEWORK_TABLE_QUERY, FILTER_GROUPS_MAP, FORM_OBJECT_TYPE } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { toFormattedString } from 'foundations-components/transitional/utils/SimpleDate';
import { LAST_THIRTY_DAYS } from 'foundations-components/transitional/components/Dates';
import { getDashboardDateRangeForPreset } from 'FormsUI/utils/date/getDashboardDateRangeForPreset';
const BASE_APP_SERVICE = 'submissions/app/v1';
const CRM_SEARCH = 'crm-search/search';
export function _countSubmissions(formGuid, dateRange) {
  return http.get(`${BASE_APP_SERVICE}/submission-report/${formGuid}/totals`, {
    query: {
      startDate: toFormattedString(dateRange.startDate, URL_DATE_FORMAT),
      endDate: toFormattedString(dateRange.endDate, URL_DATE_FORMAT)
    }
  });
}
export const countSubmissions = (formGuid, dateRange = getDashboardDateRangeForPreset(LAST_THIRTY_DAYS)) => dateRange && dateRange.type === LAST_THIRTY_DAYS.presetId ? getFromEarlyRequest(getCountSubmissionsKey(formGuid), () => _countSubmissions(formGuid, dateRange)) : _countSubmissions(formGuid, dateRange);
export function hasPropertyName(formGuid, propertyName, offset, dateRange, limit = 10, objectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.CONTACT]) {
  return http.get(`${BASE_APP_SERVICE}/submission-report/${formGuid}/${objectTypeId}/${propertyName}/values`, {
    query: {
      startDate: toFormattedString(dateRange.startDate, URL_DATE_FORMAT),
      endDate: toFormattedString(dateRange.endDate, URL_DATE_FORMAT),
      limit,
      offset
    }
  });
}
export function hasPropertyValue(formGuid, propertyName, propertyValue, offset, dateRange = {}, limit = 10, objectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.CONTACT]) {
  return http.post(`${BASE_APP_SERVICE}/submission-table`, {
    data: {
      startDate: toFormattedString(dateRange.startDate, URL_DATE_FORMAT),
      endDate: toFormattedString(dateRange.endDate, URL_DATE_FORMAT),
      limit,
      offset,
      formGuid,
      fieldValueFilter: {
        objectTypeId,
        name: propertyName,
        value: propertyValue
      }
    }
  });
}
export function getPropertyAggregations(formGuid, propertyName, dateRange, objectTypeId = PropertyObjectTypesIds[PropertyObjectTypes.CONTACT]) {
  return http.get(`${BASE_APP_SERVICE}/submission-report/${formGuid}/${objectTypeId}/${propertyName}/option-counts`, {
    query: {
      startDate: toFormattedString(dateRange.startDate, URL_DATE_FORMAT),
      endDate: toFormattedString(dateRange.endDate, URL_DATE_FORMAT),
      limit: 1000
    }
  });
}
export const _getPropertyFrequencyBuckets = (formGuid, offset, includeRequiredFields, dateRange = getDashboardDateRangeForPreset(LAST_THIRTY_DAYS)) => {
  return http.get(`${BASE_APP_SERVICE}/submission-report/${formGuid}/field-totals`, {
    query: {
      startDate: toFormattedString(dateRange.startDate, URL_DATE_FORMAT),
      endDate: toFormattedString(dateRange.endDate, URL_DATE_FORMAT),
      offset,
      includeRequiredFields
    }
  });
};
export const getPropertyFrequencyBuckets = (formGuid, offset = 0, includeRequiredFields = true, dateRange = getDashboardDateRangeForPreset(LAST_THIRTY_DAYS)) => dateRange && dateRange.type === LAST_THIRTY_DAYS.presetId ? getFromEarlyRequest(getPropertyFrequencyKey(formGuid), () => _getPropertyFrequencyBuckets(formGuid, offset, includeRequiredFields, dateRange)) : _getPropertyFrequencyBuckets(formGuid, offset, includeRequiredFields, dateRange);
const _getCrmSearchForFormsTotal = objectTypeId => http.post(CRM_SEARCH, {
  data: Object.assign({}, DEFAULT_FRAMEWORK_TABLE_QUERY, {
    filterGroups: FILTER_GROUPS_MAP[objectTypeId],
    objectTypeId,
    count: 0
  })
});
export const getCrmSearchForFormsTotal = ({
  objectTypeId
} = {
  objectTypeId: FORM_OBJECT_TYPE
}) => getFromEarlyRequest(getCRMSearchForTotalKey(objectTypeId), () => _getCrmSearchForFormsTotal(objectTypeId));
export const getCrmSearchForForms = (query = {}) => http.post(CRM_SEARCH, {
  data: Object.assign({}, DEFAULT_FRAMEWORK_TABLE_QUERY, query)
});